function Skel({ width, height = 14, circle = false, style = {} }) {
  return (
    <div
      className={`tg-skel tg-skel--${circle ? 'circle' : 'text'}`}
      style={{ width: width || '100%', height, ...style }}
    />
  )
}

export function Skeleton({ width, height = 16, radius = 4, style = {} }) {
  return <Skel width={width} height={height} style={{ borderRadius: radius, ...style }} />
}

export function KpiSkeleton() {
  return (
    <div className="tg-kpi">
      <Skel width={80} height={10} style={{ marginBottom: 8 }} />
      <Skel width={120} height={32} style={{ marginBottom: 6 }} />
      <Skel width={100} height={10} />
    </div>
  )
}

export function TruckRowSkeleton() {
  return (
    <div style={{ padding: '12px 16px', borderBottom: '0.5px solid var(--tg-border-default)', display: 'flex', gap: 12, alignItems: 'center' }}>
      <Skel width={6} height={6} circle style={{ flexShrink: 0 }} />
      <Skel width={100} height={13} />
      <div style={{ flex: 1 }} />
      <Skel width={44} height={20} style={{ borderRadius: 999 }} />
    </div>
  )
}

export function ChartSkeleton({ height = 140 }) {
  return (
    <div className="tg-skel tg-skel--block" style={{ height, borderRadius: 'var(--tg-radius-lg)' }} />
  )
}

export function CardSkeleton({ height = 80 }) {
  return (
    <div style={{ background: 'var(--tg-bg-surface)', borderRadius: 10, border: '0.5px solid var(--tg-border-default)', padding: '14px 16px', height }}>
      <Skel width={80} height={10} style={{ marginBottom: 10 }} />
      <Skel width={120} height={24} style={{ marginBottom: 6 }} />
      <Skel width={140} height={10} />
    </div>
  )
}

export function RowSkeleton() {
  return (
    <div style={{ padding: '12px 16px', borderBottom: '0.5px solid var(--tg-border-default)', display: 'flex', gap: 12, alignItems: 'center' }}>
      <Skel width={80} height={12} />
      <Skel width={140} height={14} />
      <div style={{ flex: 1 }} />
      <Skel width={60} height={12} />
      <Skel width={50} height={12} />
    </div>
  )
}

// Kept for backward compat with main.jsx shimmerKeyframes injection
export const shimmerKeyframes = '';
